module.exports = __webpack_public_path__ + "static/leeds-met-uni-sm-833d22358d086f9108b50e1d7a655167.png";